export class ServiceWorkerInitializer {
  public static register() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/Service.worker.js');
    }
  }
}
